import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/index.js'
import axios from './utils/http.js'
import Vant from 'vant';
import { Dialog } from 'vant';
import * as custom from '@/utils/filter'
import md5 from 'js-md5';
import FastClick from 'fastclick' 
import { ListenerFn } from './utils/track'

// 处理移动端300ms
// FastClick.attach(document.body)


Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
  Vue.prototype[key] = custom[key]
})

ListenerFn();

import 'vant/lib/index.css';
import '../static/css/common.css';
import '../node_modules/amfe-flexible/index.js';

//引入全局组件loading
import loading from './components/loading'
Vue.use(loading);


Vue.use(Vant);
Vue.use(Dialog);

Vue.prototype.$md5 = md5;
Vue.prototype.$http = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
	store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js